/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2020] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var Marionette = require('backbone.marionette');
var Ladda = require('ladda');
var _ = require('underscore');
var Handlebars = require('handlebars');

var showSuccessMessage = require('../../../common/util/showSuccessMessage');
var showErrorMessage = require('../../../common/util/showErrorMessage');

var AddressDisplay = require('common/views/AddressDisplayView');
var UIUtil = require('psa-core/util/ui');

var GetActiveExternalUserJoinCodes = require('../services/GetActiveExternalUserJoinCodes');
var SubmitNewExternalUserJoinCode = require('../services/SubmitNewExternalUserJoinCode');

var ConSerComplaintJoinCodeWarnModalView = require('./ConSerComplaintJoinCodeWarnModalView');
var tmplConSerContactInformationView = require('../templates/ConSerContactInformationView.hbs');

module.exports = Marionette.LayoutView.extend({
  template: tmplConSerContactInformationView,

  className: 'con-ser-contact-information-view',

  ui: {
    addressContainer: '.address-container',
    sendJoinCode: '.btn-send-join-code'
  },

  regions: {
    addressContainer: '@ui.addressContainer'
  },

  events: {
    'click @ui.sendJoinCode': 'onClickSendJoinCode'
  },

  onBeforeRender: function() {
    if (!!this.model.get('hasJoinedCSOPortal') || !this.model.get('email') || this.model.get('email') === '--') {
      this.model.set('disableSendJoinCodeButton', true);
    }
  },

  onBeforeShow: function() {
    this.showChildView('addressContainer', new AddressDisplay({ model: this.model }));
  },

  onClickSendJoinCode: function(e) {
    e.preventDefault();
    var self = this;
    var successMsgConfig = {
      successCode: 'join.code.sent',
      successTitle: 'Join Code Sent',
      successMessage:
        'A join code was sent to ' +
        self.model.attributes.firstName +
        ' ' +
        self.model.attributes.lastName +
        ' at ' +
        self.model.attributes.email +
        '.'
    };
    var errorMsgConfig = {
      errorCode: 'join.code.not.sent',
      errorTitle: 'Join Code Not Sent',
      errorMessage: 'An error occurred - please check the information or contact an administrator'
    };

    GetActiveExternalUserJoinCodes(this.model.attributes.email).done(function(joinCodes) {
      if (joinCodes.length === 0) {
        var spinner = Ladda.create(self.ui.sendJoinCode[0]);
        spinner.start();

        SubmitNewExternalUserJoinCode(
          self.model.attributes.firstName,
          self.model.attributes.lastName,
          self.model.attributes.email
        )
          .done(function() {
            spinner.stop();
            showSuccessMessage(successMsgConfig);
          })
          .fail(function() {
            spinner.stop();
            showErrorMessage(errorMsgConfig);
          });
      } else {
        var sentDates = _.map(joinCodes, function(code) {
          return code.sentDate.format('MM/DD');
        });

        Handlebars.registerHelper('inc', function(value) {
          return parseInt(value) + 1;
        });

        UIUtil.showModal({
          title: 'Send Join Codes',
          view: new ConSerComplaintJoinCodeWarnModalView({
            model: new Backbone.Model({
              sentDates: sentDates,
              onConfirm: function() {
                return SubmitNewExternalUserJoinCode(
                  self.model.attributes.firstName,
                  self.model.attributes.lastName,
                  self.model.attributes.email
                ).done(function() {
                  showSuccessMessage(successMsgConfig);
                });
              },
              onConfirmFail: function() {
                showErrorMessage(errorMsgConfig);
              }
            })
          })
        });
      }
    });
  }
});
